import React from "react";
import { Box } from "@mui/material";
import "./send-sms-popup.scss";
import closeIcon from "../../assets/icons/close-icon.svg";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { DescriptionInputComponent } from "../../common/components";

interface SendSmsPopupProps {
  setSendSmsPopupOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onSuccess?: (data: {message: string}) => void;
}

const SendSmsPopup: React.FC<SendSmsPopupProps> = ({ setSendSmsPopupOpen, onSuccess }) => {
  return (
    <div className="send-sms-popup-overlay">
      <div className="send-sms-popup">
        <div className="send-sms-popup-header">
          <div className="send-sms-popup-title">
            <h3>Send SMS</h3>
          </div>
          <div className="send-sms-popup-close">
            <img
              src={closeIcon}
              alt="Close"
              className="close-icon"
              onClick={() => setSendSmsPopupOpen(false)}
            />
          </div>
        </div>
        <Formik
          initialValues={{ message: "" }}
          validationSchema={Yup.object({
            message: Yup.string()
              .required("Message is required")
              .max(150, "Maximum 150 characters"),
          })}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(false);
            setSendSmsPopupOpen(false);
            if (onSuccess) {
              onSuccess(values);
            }
          }}
        >
          {({ isSubmitting, setFieldValue }) => (
            <Form>
              <div className="send-sms-popup-body">
                <Box flex={1}>
                  <DescriptionInputComponent
                    fieldName="message"
                    label="Message"
                    placeholder="Type Message"
                    maxlength={150}
                    minRows={2}
                    onChange={(event) => setFieldValue("message", event.target.value)}
                    optional={true}
                    renderErrorMessage={true}
                  />
                </Box>
              </div>
              <div className="send-sms-popup-actions">
                <button
                  className="send-sms-popup-cancel"
                  type="button"
                  onClick={() => setSendSmsPopupOpen(false)}
                >
                  Cancel
                </button>
                <button
                  className="send-sms-popup-send"
                  type="submit"
                  disabled={isSubmitting}
                >
                  Send
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default SendSmsPopup;
